module.exports = __webpack_public_path__ + "static/media/undraw_businessman_97x4.6af5db46.svg";